import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAuth } from '../hooks/useAuth.js';
import Calendar from './Calendar.jsx';

function AppContent() {
  const { user, logout } = useAuth();

  const getTimeBasedGreeting = () => {
    const hour = new Date().getHours();
    const firstName = user?.displayName?.split(' ')[0] || user?.email?.split('@')[0] || 'there';
    
    if (hour < 12) return `Good morning, ${firstName}!`;
    if (hour < 17) return `Good afternoon, ${firstName}!`;
    return `Good evening, ${firstName}!`;
  };

  return (
    <Box sx={{ 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      {/* Header */}
      <Box sx={{ 
        px: 3, 
        py: 2, 
        borderBottom: '1px solid rgba(0,0,0,0.08)',
        background: 'white'
      }}>
        <Typography variant="body1" sx={{ fontWeight: 600 }} color="text.secondary">
          {getTimeBasedGreeting()}
        </Typography>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 600, mt: 0.5 }}>
          BeDeliberate
        </Typography>
      </Box>
      
      {/* Calendar - takes remaining space */}
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <Calendar user={user} onLogout={logout} />
      </Box>
    </Box>
  );
}

export default AppContent;
